module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page bd"
  }, [_c('toobarhead', {
    attrs: {
      "showRefresh": false,
      "showBack": true,
      "titleName": '审批详情'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui_floor"
  }, [_c('div', {
    staticClass: "cd-container",
    attrs: {
      "id": "stock-log-timeline"
    }
  }, _vm._l((_vm.logList), function(row, index) {
    return _c('div', {
      staticClass: "cd-timeline-block"
    }, [_c('div', {
      class: ['cd-timeline-img', (index == 0) ? 'cd-even' : 'cd-odd']
    }), _vm._v(" "), _c('div', {
      staticClass: "cd-timeline-content"
    }, [_c('p', [_vm._v("【" + _vm._s(row.flowActionLabel) + "】 操作人：" + _vm._s(row.userName))]), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row.resultLabel && row.resultLabel.length > 0),
        expression: "row.resultLabel && row.resultLabel.length > 0"
      }]
    }, [_vm._v("审核结果：" + _vm._s(row.resultLabel))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(row.createTime))]), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row.comment && row.comment.length > 0),
        expression: "row.comment && row.comment.length > 0"
      }]
    }, [_vm._v("详情: " + _vm._s(row.comment))])])])
  }), 0)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-54e33714!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/logSealOut.vue
// module id = 142
// module chunks = 2